import * as React from "react";

import RemoderationForm from "~/components/Remoderation/RemoderationForm";
import client from "~/graphql/client";
import {
  ModerationOptionResolveAction,
  RESOLVE_MODERATION_OPTION_MUTATION,
  ResolveModerationOption,
  ResolveModerationOptionVariables
} from "~/graphql/mutations/optionRemoderation/resolveModerationOption";
import { IModerationOption } from "~/graphql/queries/optionRemoderation/optionsPendingRemoderation";
import { ResolveModerationOptionInput } from "~/graphql/types";
import ModerationActivityManager from "~/util/registerModerationActivity";

interface IProps {
  moderationOption: IModerationOption;
  onNextModerationOption: () => void;
}

interface IState {
  image: Blob | undefined;
  input: ResolveModerationOptionInput;
  src: string | null;
}

export default class RemoderationFormContainer extends React.Component<
  IProps,
  IState
> {
  public static getDerivedStateFromProps(
    props: IProps,
    state: IState
  ): IState | null {
    if (props.moderationOption.id !== state.input.id) {
      return {
        ...state,
        input: {
          id: props.moderationOption.id,
          imageId:
            props.moderationOption.image &&
            props.moderationOption.image.nesImageId
        },
        src: props.moderationOption.image && props.moderationOption.image.url
      };
    }

    return null;
  }

  public readonly state: IState = {
    image: undefined,
    input: {},
    src: null
  };

  public render() {
    const { moderationOption } = this.props;
    const { src } = this.state;

    return (
      <RemoderationForm
        moderationOption={moderationOption}
        canvasSrc={src}
        onImageCanvasCommit={this.handleImageCanvasCommit}
        onAlternativeImageClick={this.handleAlternativeImageClick}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
      />
    );
  }

  private handleAlternativeImageClick = (imageId: string, src: string) =>
    this.setState(state => ({
      ...state,
      input: { ...state.input, imageId },
      src
    }));

  private handleImageCanvasCommit = (file: File) =>
    this.setState(state => ({ input: { ...state.input, file } }));

  private handleSubmit = () => {
    ModerationActivityManager.registerModerationActivity(
      "submit_remoderation",
      this.props.moderationOption.id
    );

    this.props.onNextModerationOption();

    const resolveAction =
      this.props.moderationOption.image!.nesImageId === this.state.input.imageId
        ? ModerationOptionResolveAction.UPDATE
        : ModerationOptionResolveAction.REPLACE;

    client.mutate<ResolveModerationOption, ResolveModerationOptionVariables>({
      mutation: RESOLVE_MODERATION_OPTION_MUTATION,
      variables: {
        input: {
          ...this.state.input,
          resolveAction
        }
      }
    });
  };

  private handleDelete = () => {
    ModerationActivityManager.registerModerationActivity(
      "delete_remoderation",
      this.props.moderationOption.id
    );

    this.props.onNextModerationOption();

    client.mutate<ResolveModerationOption, ResolveModerationOptionVariables>({
      mutation: RESOLVE_MODERATION_OPTION_MUTATION,
      variables: {
        input: {
          id: this.props.moderationOption.id,
          resolveAction: ModerationOptionResolveAction.DELETE
        }
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/containers/RemoderationFormContainer.tsx